
    var doc = {"kind":"Document","definitions":[{"kind":"DirectiveDefinition","name":{"kind":"Name","value":"client"},"arguments":[],"repeatable":false,"locations":[{"kind":"Name","value":"FIELD"}]}],"loc":{"start":0,"end":187}};
    doc.loc.source = {"body":"# This directive is built into GQL but not dumped as part of the schema. This is just so our lint tooling\n# on the frontend is able to recognize the directive.\ndirective @client on FIELD\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
